import React from "react";
import { Image } from "react-bootstrap";
import { PAYMENT_STATUS } from "../../../../../enums/OrderEnums";
import { PAYMENT_STATUS_BADGE } from "../../../../../enums/StatusBadges";
import moment from "moment";

function TableHeadEvents(props) {
  return (
    <tr>
      <th style={{ width: "180px" }}>
        Event Ticket Type/
        <br />
        Event ID
      </th>
      <th style={{ width: "150px" }}>User Name</th>
      <th style={{ width: "150px" }}>
        Event Status <br />
        /Date & Time
      </th>
      <th style={{ width: "150px" }}>
        Total PAX/
        <br /> Ticket No.
      </th>
      <th style={{ width: "150px" }}>
        Ticket Total <br />
        Amount
      </th>
      <th style={{ width: "150px" }}>GST</th>
      <th style={{ width: "150px" }}>
        Service
        <br /> Charge (10%)
      </th>
      <th style={{ width: "150px" }}>
        CC <br />
        Charges
      </th>
      <th style={{ width: "150px" }}>Net Remitted</th>
      <th style={{ width: "150px" }}>Discount</th>
      <th style={{ width: "150px" }}>Donation</th>
      <th style={{ width: "150px" }}>
        Payment Status <br />
        /Date & Time
      </th>
      <th style={{ width: "150px" }}>
        Payment Method/ <br />
        Transaction ID
      </th>
      <th style={{ width: "150px" }}>
        Remittance <br />
        Status/ID
      </th>
      <th style={{ width: "150px" }}>
        Merchant Account <br />
        No. & IFSC
      </th>
      <th style={{ width: "150px" }}>
        Settlement Date <br />& Time
      </th>
    </tr>
  );
}

export default TableHeadEvents;

export const TableBodyEvents = (props) => {
  const data = props.data;
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                className="sd_body_table-row"
                // style={{ textAlign: "center" }}
              >
                <td style={{ width: "150px" }} className="text-center">
                  <div className="f12-500">
                    {data?.eventHandler?.event_type}
                  </div>
                  <div className="f12-400">
                    {data?.eventHandler?.event_id?.event_id}
                  </div>
                </td>
                <td style={{ width: "150px" }} className="text-center">
                  <div className="f12-500">
                    {data?.eventHandler?.user_id?.first_name}{" "}
                    {data?.eventHandler?.user_id?.last_name}
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  {data?.eventHandler?.event_status === "CANCELLED" && (
                    <div className="badge badge-danger">
                      {data?.eventHandler?.event_status}
                    </div>
                  )}
                  {data?.eventHandler?.event_status !== "CANCELLED" && (
                    <div className="badge badge-success">
                      {data?.eventHandler?.event_status}
                    </div>
                  )}
                  <div className="f12-500">
                    {moment(data?.order?.transactional_id?.createdAt).format(
                      "ll"
                    )}
                    <br />
                    {moment(data?.order?.transactional_id?.createdAt).format(
                      "LT"
                    )}
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    {data?.eventHandler?.adult_count +
                      data?.eventHandler?.kids_count}{" "}
                    PAX
                    {/* /<br /> */}
                    {/* 2145368 */}
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">₹ -</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">₹ -</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">₹ -</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">₹ -</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">₹ -</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">₹ -</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">₹ -</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div
                    className={`badge badge-${
                      PAYMENT_STATUS_BADGE[data?.eventHandler?.payment_status]
                    }`}
                  >
                    {PAYMENT_STATUS[data?.eventHandler?.payment_status]}
                  </div>

                  <div className="f12-500">
                    {moment(
                      data?.eventHandler?.transactional_id?.createdAt
                    ).format("ll")}
                    <br />
                    {moment(
                      data?.eventHandler?.transactional_id?.createdAt
                    ).format("LT")}
                    {/* 25th Aug, 2020 <br />
                    09:15 PM */}
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">Debit Card</div>
                  <div className="f12-500">1245789632</div>
                </td>
                <td style={{ width: "150px" }}>
                  {data?.settle_payment_status && (
                    <div className="badge badge-success p-2">Settled</div>
                  )}
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    {data?.settlement_account_details?.account_number}/{" "}
                  </div>
                  <div className="f12-500">
                    {data?.settlement_account_details?.account_ifsc}
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    {moment(data?.createdAt).format("ll")}
                    <br />
                    {moment(data?.createdAt).format("LT")}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};
